import { HStack, Tooltip } from '@chakra-ui/react';
// import { FiMail } from 'react-icons/fi';

export const EmailLink = (props: {
  name?: string;
  email?: string;
}) => {
  const href = `mailto:${props.email}`;
  const style = {
    whiteSpace: 'nowrap',
    textDecoration: 'underline',
    marginRight: '8px',
  };
  return (
    <HStack style={style}>
      <Tooltip label={props.email}>
        <a href={href} dangerouslySetInnerHTML={{ __html: props.name || props.email || '' }} />
      </Tooltip>
    </HStack>
  )
}